<script setup lang="ts">
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'HeaderUsers',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  { id: 'users', text: 'Users & teams', to: AppRoute.Users, disabled: true },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
